module.exports = __webpack_public_path__ + "vue/img/stu_avatar2.716d9247.png";